import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTiktok, faInstagram, faLine } from '@fortawesome/free-brands-svg-icons';
// import './index.css';
const slideImages = [
  "/rooms/std.jpg",
  "/rooms/dl1.jpg",
  "/rooms/dl2.jpg",
  "/rooms/dlv1.jpg",
  "/rooms/dlv2.jpg",
  "/rooms/spr.jpg",
  "/rooms/fml.jpg",
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

export default function CatHotelLandingPage() {
  const [selectedImage, setSelectedImage] = useState(null);
  // const [posts, setPosts] = useState([]);

  const handleClickZoom = (imgUrl) => {
    setSelectedImage(imgUrl);
  };

  const handleClose = () => {
    setSelectedImage(null);
  }; 
  const lat = 13.632656733247263;
  const lng = 100.6294415367814;

  // ลิงก์เปิด directions ไปที่ร้าน
  const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat.toString()},${lng.toString()}&hl=th`;
  const mapsUrl = `https://www.google.com/maps?q=${lat.toString()},${lng.toString()}&hl=th&z=16&output=embed`;
  // useEffect(() => {
  //   fetch('https://graph.facebook.com/v18.0/nekoguruguru/posts?limit=5&access_token=2599210237081438|YehXeh0D2sXIsYd6ExlsaASA4s')
  //     .then(res => res.json())
  //     .then(data => setPosts(data.data));
  // }, []);

  return (
    <div className="flex flex-col md:flex-row justify-center">
      {/* บล็อกซ้าย - ส่วนที่ 1 */}
      <div className="w-full md:w-1/2">
        <div className="md:min-h-screen bg-[#FFF8EF] flex flex-col items-center p-4 text-[#3A2B1C] font-sans">
          {/* Logo & Live Cam Button */}
          <div className="w-full max-w-md mt-0 flex justify-between items-center mb-2">
            <img src="/logo.png" alt="Neko Guru Logo" className="w-36" />
            <Link
              to="/live"
              className="bg-[#FFA726] hover:bg-[#ff9800] text-white font-bold text-xs px-3.5 py-2 rounded-full shadow-md flex items-center gap-1.5 transition transform hover:scale-105"
            >
              <span>📹</span> ดูกล้องห้องแมวสด
            </Link>
          </div>

          <Slider {...sliderSettings} className="w-full max-w-md mt-2">
            <div key="0">
              {/* Title */}
              <h1 className="text-3xl sm:text-4xl font-bold text-[#3A2B1C] text-center">บริการรับฝากแมว</h1>

              {/* Package options */}
              <div className="flex justify-center gap-3 mt-4">
                <span className="px-3 py-1 rounded-full border text-sm text-[#3A2B1C] bg-white">รายวัน</span>
                <span className="px-3 py-1 rounded-full text-sm text-white bg-[#7C482C]">รายเดือน</span>
                <span className="px-3 py-1 rounded-full text-sm text-white bg-[#FFA726]">รายปี</span>
              </div>

              {/* Price */}
              <div className="flex justify-center mt-20 text-xl sm:text-4xl font-bold">
                เริ่มต้น
                <span className="inline-block bg-[#FFF3D3] rounded-full border-4 border-[#FFA726] px-4 py-2 ml-2 text-[#f1403e] text-4xl font-bold rotate-[350deg] shadow-lg">
                  300.-
                </span>
              </div>
            </div>
            {slideImages.map((src, index) => (
              <div key={index+1}>
                <img src={src} alt={`slide-${index}`} className="rounded-lg w-full h-auto" 
                  onClick={() => handleClickZoom(src)}
                  style={{ cursor: 'zoom-in' }}
                />
              </div>
            ))}
          </Slider>

          
          
        </div>
      </div>
      {/* บล็อกขวา - ส่วนที่ 2 */}
      {/* <div className="w-full md:w-1/3">
        <div className="md:min-h-screen bg-[#FFF8EF] flex flex-col items-center p-4 text-[#3A2B1C] font-sans">
          <div className="mt-6 w-full max-w-md md:mt-6">
            <h2 className="text-center text-lg font-bold mb-4">Activities</h2>
            {Array.isArray(posts) && posts.map(post => (
              <div key={post.id} style={{ marginBottom: '1rem' }}>
                <p>{post.message}</p>
                <p style={{ color: 'gray' }}>{new Date(post.created_time).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      {/* บล็อกขวา - ส่วนที่ 3 */}
      <div className="w-full md:w-1/2 md:border-l">
        {/* Content กรอบ 3 */}
        <div className="min-h-screen bg-[#FFF8EF] flex flex-col items-center p-4 text-[#3A2B1C] font-sans">
          {/* Follow Us Section */}
          <div className="mt-6 w-full max-w-md md:mt-6">
            <h2 className="text-center text-lg font-bold mb-4">Contact Us</h2>

            {/* Contact Section Styled Like Image 2 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Line QR Left */}
              <div className="flex flex-col justify-between items-center bg-[#FFF1DC] rounded-lg p-3 shadow-md">
                <a
                  href="https://line.me/R/ti/p/@542waerp"
                  className="text-black no-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-[#FFA726] font-bold text-center leading-tight"><FontAwesomeIcon icon={faLine} /> Neko Guru                       
                    <button class="w-6 h-6 ml-1 bg-orange-400 text-white text-xs font-bold rounded-full hover:bg-orange-500 transition shadow-md">
                      GO
                    </button>
                  </span>
                </a>
                <img
                  src="/qr-line.jpg"
                  alt="Line QR"
                  className="w-32 h-32 mt-2 border rounded"
                  onClick={() => handleClickZoom("/qr-line.jpg")}
                  style={{ cursor: 'zoom-in' }}
                />
                {/* Contact */}
                <div className="text-center mt-2 text-base font-semibold text-[#3A2B1C]">
                <a
                  href="tel:0955436544"
                  className="text-black no-underline"
                ><FontAwesomeIcon icon={faPhone} className="mr-2 text-gray-700" /> 0955436544</a>
                </div>
              </div>

              {/* Vertical Socials */}
              <div className="flex flex-col gap-3 w-full">
                <div className="flex items-center gap-3">
                  <img src="/qr-fb.jpg" alt="FB QR" className="w-16 h-16 border rounded" 
                    onClick={() => handleClickZoom("/qr-fb.jpg")}
                    style={{ cursor: 'zoom-in' }}
                  />
                  <a
                    href="https://www.facebook.com/nekogurucathotel"
                    className="text-black no-underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-sm leading-tight">
                    <FontAwesomeIcon icon={faFacebookF} /> Facebook
                      <button class="w-6 h-6 ml-7 bg-orange-400 text-white text-xs font-bold rounded-full hover:bg-orange-500 transition shadow-md">
                        GO
                      </button>
                      <br />nekogurucathotel
                    </span>
                    
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <img src="/qr-tt.jpg" alt="Tiktok QR" className="w-16 h-16 border rounded" 
                    onClick={() => handleClickZoom("/qr-tt.jpg")}
                    style={{ cursor: 'zoom-in' }}
                  />
                  <a
                    href="https://www.tiktok.com/@nekoguru.cathotel"
                    className="text-black no-underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-sm leading-tight">
                      <FontAwesomeIcon icon={faTiktok} /> Tiktok
                      <button class="w-6 h-6 ml-12 bg-orange-400 text-white text-xs font-bold rounded-full hover:bg-orange-500 transition shadow-md">
                        GO
                      </button>
                      <br />@nekoguru.cathotel
                    </span>
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <img src="/qr-ig.png" alt="IG QR" className="w-16 h-16 border rounded" 
                    onClick={() => handleClickZoom("/qr-ig.png")}
                    style={{ cursor: 'zoom-in' }}
                  />
                  <a
                    href="https://www.instagram.com/nekoguru.cat.hotel"
                    className="text-black no-underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-sm leading-tight ">
                      <FontAwesomeIcon icon={faInstagram} /> Instagram
                      <button class="w-6 h-6 ml-6 bg-orange-400 text-white text-xs font-bold rounded-full hover:bg-orange-500 transition shadow-md">
                        GO
                      </button>
                      <br />@nekoguru.cat.hotel
                    </span>
                  </a>
                </div>
                {/* Popup modal */}
                {selectedImage && (
                  <div
                    onClick={handleClose}
                    style={{
                      position: 'fixed',
                      top: 0, left: 0, right: 0, bottom: 0,
                      backgroundColor: 'rgba(0,0,0,0.8)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 1000,
                    }}
                  >
                    <img 
                      src={selectedImage} 
                      alt="Zoomed" 
                      style={{ maxWidth: '90%', maxHeight: '90%' }} 
                    />
                  </div>
                )}
              </div>
            </div>
          
          </div>

          {/* Map Section */}
          <div className="mt-6 w-full max-w-md">
            <h2 className="text-center text-lg font-bold mb-2">Maps</h2>
            <iframe
              src={mapsUrl}
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="แผนที่ร้าน"
            ></iframe>

            {/* ปุ่มไป Google Maps */}
            <a
              href={directionUrl}
              className="text-black no-underline flex items-center justify-center mt-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>เปิดนำทางด้วย Google Maps</span>
              <button type="button" className="w-6 h-6 ml-2 bg-orange-400 text-white text-xs font-bold rounded-full hover:bg-orange-500 transition shadow-md">
                GO
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Floating Action Button: ดูกล้องห้องน้องแมวสด */}
      <Link
        to="/live"
        className="fixed bottom-6 right-6 z-50 bg-[#FFA726] hover:bg-[#ff9800] text-white font-bold px-4 sm:px-5 py-3 sm:py-3.5 rounded-full shadow-2xl flex items-center gap-2 border-2 border-white transition transform hover:scale-105 active:scale-95"
      >
        <span className="text-xl">📹</span>
        <span className="text-sm font-semibold">ดูกล้องน้องแมวสด</span>
      </Link>
    </div>  
  );
}
